import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { CapabilityType } from 'src/app/models/capability-type';
import { PlanogramProductStack } from 'src/app/models/layout/planogram-product-stack';
import { CapabilitiesService } from 'src/app/services/capabilities.service';
import { DragContextService } from 'src/app/services/dragcontext.service';
import { PlaceholderService } from 'src/app/services/placeholder.service';
import { NgIf, AsyncPipe } from '@angular/common';
import { PlanogramManualProductComponent } from '../planogram-manual-product/planogram-manual-product.component';

@Component({
    selector: 'app-planogram-manual-product-stack',
    templateUrl: './planogram-manual-product-stack.component.html',
    styleUrl: './planogram-manual-product-stack.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, PlanogramManualProductComponent, AsyncPipe]
})
export class PlanogramManualProductStackComponent {
  @Input() stack!: PlanogramProductStack;
  @Input() dropIndex!: number;
  @Input() shelfIndex!: number;
  @Input() stackIndex!: number;

  constructor(
    private dragContextService: DragContextService,
    private capabilitiesService: CapabilitiesService,
    public placeholderService: PlaceholderService
  ) {}

  onDragOver(event: MouseEvent) {
    if (!this.dragContextService.isDraggingProduct()) return;
    {{ if (!this.capabilitiesService.hasCapability(CapabilityType.EDIT_PLANOGRAM)) return; }}

    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const relativeX = (event.clientX - rect.left) / rect.width;
    const insideStackCore = relativeX > 0.25 && relativeX < 0.75;

    if (insideStackCore) {
      // We're in the core of the stack - handle product placement within stack
      // NO stopPropagation() here!

      const position = this.calculateProductPosition(event);
      const product = this.dragContextService.getContext()?.draggedProduct;

      if (product) {
        this.placeholderService.setProductPlaceholder(
          this.dropIndex,
          this.shelfIndex,
          this.stackIndex,
          position,
          product
        );
      }
    }
    // Let the event continue to bubble up to shelf for stack positioning
  }

  onDragLeave(event: MouseEvent) {
    if (!this.dragContextService.isDraggingProduct()) return;
    {{ if (!this.capabilitiesService.hasCapability(CapabilityType.EDIT_PLANOGRAM)) return; }}

    const relatedTarget = event.relatedTarget as HTMLElement;
    const currentTarget = event.currentTarget as HTMLElement;

    // Only clear if actually leaving the stack
    if (!relatedTarget || !currentTarget.contains(relatedTarget)) {
      this.placeholderService.clearPlaceholder();
    }
  }

  private calculateProductPosition(event: MouseEvent): number {
    const stackElement = event.currentTarget as HTMLElement;
    const productElements = Array.from(
      stackElement.querySelectorAll('app-planogram-manual-product')
    ) as HTMLElement[];

    if (productElements.length === 0) return 0;

    const mouseY = event.clientY;

    for (let i = 0; i < productElements.length; i++) {
      const productRect = productElements[i].getBoundingClientRect();
      const productCenter = productRect.top + productRect.height / 2;

      if (mouseY < productCenter) {
        return i; // Insert before this product
      }
    }

    return productElements.length; // Insert at the end (top of stack)
  }
}
